/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateCommitRequest {
    getFixupPrototypeFunction() { return TemplateCommitRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateCommitRequest>): TemplateCommitRequest {
        let obj = Object.assign(new TemplateCommitRequest(), model);
        TemplateCommitRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateCommitRequest>): TemplateCommitRequest {
        if (!model) return null;
        return TemplateCommitRequest.newInstance(<TemplateCommitRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateCommitRequest) {
        if (!obj) return;

        models.TemplateCommitRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateCommitRequest): boolean {
        Object.setPrototypeOf(obj, TemplateCommitRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.git_details) {
            models.TemplateCommitGitDetails.fixupPrototype(this.git_details);
        }
        if (this.args) {
            for (let val of this.args) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    git_details: models.TemplateCommitGitDetails;

    /**
     * Resolved parameter values to commit
     */
    args: Array<models.NamedParameter>;

}
